import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch, AppThunk } from "@/app/store";
import { createDraftInvoice } from "@/api/createDraftInvoice/createDraftInvoiceApi";
import {
  CreateDraftInvoiceRequest,
  CreateDraftInvoiceResponse,
  DraftInvoiceResponse,
} from "@/api/createDraftInvoice/types";

interface DraftInvoiceState {
  invoice: DraftInvoiceResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: DraftInvoiceState = {
  invoice: null,
  loading: false,
  error: null,
};

const draftInvoiceSlice = createSlice({
  name: "draftInvoice",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setDraftInvoice: (state, action: PayloadAction<DraftInvoiceResponse>) => {
      state.invoice = action.payload;
    },
    clearDraftInvoice: () => initialState,
  },
});

export const { setLoading, setError, setDraftInvoice, clearDraftInvoice } =
  draftInvoiceSlice.actions;

export const createDraftInvoiceAction =
  (requestData: CreateDraftInvoiceRequest): AppThunk =>
  async (dispatch: AppDispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));
    try {
      const response: CreateDraftInvoiceResponse =
        await createDraftInvoice(requestData);
      dispatch(setDraftInvoice(response.data));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(setError(error.message));
      } else {
        dispatch(setError("Failed to create draft invoice"));
      }
    } finally {
      dispatch(setLoading(false));
    }
  };

export default draftInvoiceSlice.reducer;
